import { render, staticRenderFns } from "./BcBtnAdd.vue?vue&type=template&id=19a433a2"
import script from "./BcBtnAdd.vue?vue&type=script&lang=js"
export * from "./BcBtnAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports